import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";

export default function About() {
  return (
    <>
      <Seo
        title="About us | Reliance Motor Claims Recovery"
        description="Reliance Motor Claims Recovery helps not-at-fault drivers get back on the road. We manage your not-at-fault claim, replacement hire vehicle, storage and repairs, and claim the costs from the at-fault party's insurer."
        path="/about"
      />

      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
          <p className="font-saira font-semibold text-xs sm:text-sm tracking-widest uppercase text-steel border-l-4 border-road pl-3">
            About us
          </p>
          <h1 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight text-ink max-w-3xl">
            We take the stress out of insurance claims
          </h1>
        </div>
      </section>

      <section className="bg-mist">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
          <div className="bg-white rounded-2xl p-6 sm:p-10 border-l-8 border-road">
            <p className="text-base sm:text-lg leading-relaxed text-ink">
              Reliance Motor Claims Recovery helps drivers get back on the road after an
              accident that wasn't their fault. We take the stress out of dealing with
              insurers by managing your claim from start to finish: we lodge the claim, deal
              directly with the at-fault party's insurer, and negotiate to recover your
              losses, including repairs, replacement vehicle costs and storage.
            </p>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-ink">
              While we handle the claim, we keep you moving with a replacement car from our
              own fleet and store your damaged vehicle securely at our premises. For
              not-at-fault drivers, we claim the costs from the at-fault insurer – not from
              you.
            </p>
            <a
              href="/claim"
              className="mt-8 inline-flex items-center justify-center gap-2 min-h-[48px] px-7 bg-ink text-white font-saira font-bold rounded hover:bg-black transition-colors"
              data-testid="about-start-claim-button"
            >
              Start your claim
              <ArrowRight className="size-5" aria-hidden="true" />
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
